import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBagIcon, ArrowLeftIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { CartItem } from '../components/cart/CartItem';
import { CartSummary } from '../components/cart/CartSummary';
import { Button } from '../components/ui/Button';
export function CartPage() {
  const {
    items,
    itemCount
  } = useCart();
  const navigate = useNavigate();
  if (items.length === 0) {
    return <div className="min-h-screen bg-gray-50 py-12" data-id="element-1080">
        <div className="max-w-7xl mx-auto px-4" data-id="element-1081">
          <div className="text-center py-16" data-id="element-1082">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1083">
              <ShoppingBagIcon className="w-12 h-12 text-gray-400" data-id="element-1084" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1085">
              Your cart is empty
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1086">
              Looks like you haven't added any items to your cart yet.
            </p>
            <Link to="/products" data-id="element-1087">
              <Button variant="primary" size="lg" data-id="element-1088">
                Continue Shopping
              </Button>
            </Link>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 py-6" data-id="element-1089">
      <div className="max-w-7xl mx-auto px-4" data-id="element-1090">
        {/* Header */}
        <div className="flex items-center justify-between mb-6" data-id="element-1091">
          <div data-id="element-1092">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-1093">
              Shopping Cart
            </h1>
            <p className="text-gray-600" data-id="element-1094">{itemCount} items in your cart</p>
          </div>
          <Link to="/products" className="flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium" data-id="element-1095">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-1096" />
            Continue Shopping
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1097">
          {/* Cart items */}
          <div className="lg:col-span-2" data-id="element-1098">
            <div className="bg-white rounded-xl shadow-card p-6" data-id="element-1099">
              {items.map(item => <CartItem key={item.product.id} item={item} data-id="element-1100" />)}
            </div>
          </div>

          {/* Order summary */}
          <div className="lg:col-span-1" data-id="element-1101">
            <div className="sticky top-32" data-id="element-1102">
              <CartSummary onCheckout={() => navigate('/checkout')} data-id="element-1103" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}